/**
 * @generated SignedSource<<9f3edcde82fee5b5e48528c19971777a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ElementTypeV2 = "clozeText" | "file" | "multipleChoice" | "order" | "podcast" | "randomMultipleChoice" | "text" | "video" | "%future added value";
export type SearchLearnOpportunitiesFormatTypeInput = "Heft" | "Podcast" | "Video" | "%future added value";
export type SearchLearnOpportunitiesOrderByInput = "alphabetical" | "date" | "relevancy" | "%future added value";
export type SearchLearnOpportunitiesSearchOptionsInput = "hideFinished" | "hideStarted" | "hideTreeNotRewarded" | "onlyShowActive" | "onlyShowBasisSeminar" | "onlyShowFinished" | "onlyShowStarted" | "showNonVisibleIfIssuedCertificateAvailable" | "%future added value";
export type SearchLearnOpportunitiesSortDirectionInput = "asc" | "desc" | "%future added value";
export type SearchResults_Query$variables = {
  elementTypes?: ReadonlyArray<ElementTypeV2> | null;
  formatTypes?: ReadonlyArray<SearchLearnOpportunitiesFormatTypeInput> | null;
  isCertified?: boolean | null;
  orderBy?: SearchLearnOpportunitiesOrderByInput | null;
  query?: string | null;
  searchOptions?: ReadonlyArray<SearchLearnOpportunitiesSearchOptionsInput> | null;
  sortDirection?: SearchLearnOpportunitiesSortDirectionInput | null;
  tagIds?: ReadonlyArray<string> | null;
};
export type SearchResults_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SearchResults_LearnOpportunitiesFragment">;
};
export type SearchResults_Query = {
  response: SearchResults_Query$data;
  variables: SearchResults_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "elementTypes"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "formatTypes"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCertified"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchOptions"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDirection"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagIds"
},
v8 = {
  "kind": "Variable",
  "name": "elementTypes",
  "variableName": "elementTypes"
},
v9 = {
  "kind": "Variable",
  "name": "formatTypes",
  "variableName": "formatTypes"
},
v10 = {
  "kind": "Variable",
  "name": "isCertified",
  "variableName": "isCertified"
},
v11 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v12 = {
  "kind": "Variable",
  "name": "query",
  "variableName": "query"
},
v13 = {
  "kind": "Variable",
  "name": "searchOptions",
  "variableName": "searchOptions"
},
v14 = {
  "kind": "Variable",
  "name": "sortDirection",
  "variableName": "sortDirection"
},
v15 = {
  "kind": "Variable",
  "name": "tagIds",
  "variableName": "tagIds"
},
v16 = [
  (v8/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v20 = [
  (v19/*: any*/),
  (v17/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchResults_Query",
    "selections": [
      {
        "args": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SearchResults_LearnOpportunitiesFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SearchResults_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnV2Queries",
        "kind": "LinkedField",
        "name": "LearnV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v16/*: any*/),
            "concreteType": "LearnOpportunitiesV2Connection",
            "kind": "LinkedField",
            "name": "SearchLearnOpportunities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LearnOpportunitiesV2Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LearnOpportunityV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shortDescription",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "extension",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "internalCode",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "lengthInSecondsOverride",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isVisibleOnlyForAdmins",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "WordpressCertificateAndLearnState",
                                        "kind": "LinkedField",
                                        "name": "wordpressCertificates",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "finishedAt",
                                            "storageKey": null
                                          },
                                          (v17/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "File",
                                            "kind": "LinkedField",
                                            "name": "certificateFile",
                                            "plural": false,
                                            "selections": [
                                              (v17/*: any*/),
                                              (v19/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "firstLearnOpportunityIdWithMultipleChoiceElement",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "InfectopharmTreeConfigConsequences",
                                        "kind": "LinkedField",
                                        "name": "configConsequences",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "rewardExpired",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "IssuedCertificateV2",
                                        "kind": "LinkedField",
                                        "name": "issuedCertificates",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "issuedAt",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "File",
                                            "kind": "LinkedField",
                                            "name": "fileRef",
                                            "plural": false,
                                            "selections": (v20/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ReducedDataInTree",
                                        "kind": "LinkedField",
                                        "name": "reducedDataInTree",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "pacPoints",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "pharmaPoints",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "certificateTemplateNames",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "elementTypes",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "LearnOpportunityRootExtensionImpl",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "File",
                                "kind": "LinkedField",
                                "name": "icon",
                                "plural": false,
                                "selections": (v20/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "progressPercentage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Tag",
                                "kind": "LinkedField",
                                "name": "tags",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "colorHex",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnOpportunityRootStructureDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v16/*: any*/),
            "filters": [
              "query",
              "tagIds",
              "orderBy",
              "searchOptions",
              "sortDirection",
              "elementTypes",
              "isCertified",
              "formatTypes"
            ],
            "handle": "connection",
            "key": "SearchResults_SearchLearnOpportunities",
            "kind": "LinkedHandle",
            "name": "SearchLearnOpportunities"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8fd0febbf50a64f0a1ae9c28a1721fb0",
    "id": null,
    "metadata": {},
    "name": "SearchResults_Query",
    "operationKind": "query",
    "text": "query SearchResults_Query(\n  $query: String\n  $tagIds: [ID!]\n  $orderBy: SearchLearnOpportunitiesOrderByInput\n  $searchOptions: [SearchLearnOpportunitiesSearchOptionsInput!]\n  $sortDirection: SearchLearnOpportunitiesSortDirectionInput\n  $elementTypes: [ElementTypeV2!]\n  $isCertified: Boolean\n  $formatTypes: [SearchLearnOpportunitiesFormatTypeInput!]\n) {\n  ...SearchResults_LearnOpportunitiesFragment_c3psJ\n}\n\nfragment NodeCard_NodeFragment on LearnOpportunityV2 {\n  id\n  shortDescription\n  structureDefinition {\n    __typename\n    title\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          internalCode\n          lengthInSecondsOverride\n          isVisibleOnlyForAdmins\n          wordpressCertificates {\n            finishedAt\n            id\n            certificateFile {\n              id\n              url\n            }\n          }\n          firstLearnOpportunityIdWithMultipleChoiceElement\n          configConsequences {\n            rewardExpired\n          }\n          issuedCertificates {\n            issuedAt\n            fileRef {\n              url\n              id\n            }\n          }\n          reducedDataInTree {\n            pacPoints\n            pharmaPoints\n            certificateTemplateNames\n          }\n        }\n      }\n      icon {\n        url\n        id\n      }\n      progressPercentage\n      ...NodeTagList_LearnOpportunityRootStructureDefinitionFragment\n      ...NodeCertificateDisplay_NodeRootStructureDefinitionFragment\n      ...NodePointsDisplay_NodeRootStructureDefinitionFragment\n    }\n  }\n  ...NodeIcons_NodeFragment\n}\n\nfragment NodeCertificateDisplay_NodeRootStructureDefinitionFragment on LearnOpportunityRootStructureDefinition {\n  extension {\n    __typename\n    ... on LearnOpportunityRootExtensionImpl {\n      reducedDataInTree {\n        certificateTemplateNames\n      }\n    }\n  }\n}\n\nfragment NodeIcons_NodeFragment on LearnOpportunityV2 {\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          reducedDataInTree {\n            elementTypes\n          }\n        }\n      }\n    }\n  }\n  ...ProjectNodeIcons_NodeFragment\n}\n\nfragment NodePointsDisplay_NodeRootStructureDefinitionFragment on LearnOpportunityRootStructureDefinition {\n  extension {\n    __typename\n    ... on LearnOpportunityRootExtensionImpl {\n      reducedDataInTree {\n        pacPoints\n        pharmaPoints\n      }\n    }\n  }\n}\n\nfragment NodeTagList_LearnOpportunityRootStructureDefinitionFragment on LearnOpportunityRootStructureDefinition {\n  tags {\n    id\n    ...NodeTag_TagFragment\n  }\n}\n\nfragment NodeTag_TagFragment on Tag {\n  id\n  name\n  colorHex\n}\n\nfragment ProjectNodeIcons_NodeFragment on LearnOpportunityV2 {\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          reducedDataInTree {\n            elementTypes\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment SearchResults_LearnOpportunitiesFragment_c3psJ on Query {\n  LearnV2 {\n    SearchLearnOpportunities(first: 20, query: $query, tagIds: $tagIds, orderBy: $orderBy, searchOptions: $searchOptions, sortDirection: $sortDirection, elementTypes: $elementTypes, isCertified: $isCertified, formatTypes: $formatTypes) {\n      pageInfo {\n        endCursor\n        hasPreviousPage\n        hasNextPage\n        startCursor\n      }\n      edges {\n        node {\n          ...NodeCard_NodeFragment\n          id\n          __typename\n        }\n        cursor\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6d753915b084c214c9af65b265aee8d9";

export default node;
